import sidebar from '@/config/sidebars/adminCompanyCam'
import createVueApp from '@/common/createApp'

const mountForm = async(props) => {
  const { default: FormPage } = await import('@/vue_widgets/admin/company_cam/api_keys/form.vue')
  createVueApp(FormPage, { props, sidebar })
}

Styxie.Initializers.AdminCompanyCamApiKeys = {
  index: async(props) => {
    const { default: IndexPage } = await import('@/vue_widgets/admin/company_cam/api_keys/index.vue')
    createVueApp(IndexPage, { props, sidebar })
  },
  new: mountForm,
  edit: mountForm
}
